import Reddit from './Reddit'

export default Reddit
// eslint-disable-next-line import/export
export * from './Reddit'
